module.exports = __webpack_public_path__ + "img/control_de_calidad3_4-3_1536.c2af6588.webp";